export default __webpack_public_path__ + "static/media/Privacy-Policy.d37515e8.jpg";